import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getProgressList } from "../../api/const";
import BoardTable from "../../components/common/board/BoardTable";
import BoardToolbar from "../../components/common/board/BoardToolbar";
import PageHeader from "../../components/common/ui/PageHeader";
import BoardPagination from "../../components/common/board/BoardPagination";
import SearchBar from "../../components/common/board/SearchFilterBar";
import { softDeleteDoc } from "../../api/papers";

export default function ProgressList() {
  const { id: projectId } = useParams();
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // 필터 관련 (WorkOrder와 동일 구조)
  const [q, setQ] = useState("");
  const [searchField, setSearchField] = useState("title");
  const [dateFilter, setDateFilter] = useState("all"); // 추가
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchTrigger, setSearchTrigger] = useState(0);

  // 페이지 관련
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [total, setTotal] = useState(0);

  // 상태
  const [deleting, setDeleting] = useState(false);

  // 테이블 컬럼
  const columns = [
    { key: "title", header: "제목" },

    {
      key: "doc_type",
      header: "종류",
      render: (row) => (row.doc_type === "weekly" ? "주간" : "월간"),
    },
    {
      key: "created_by",
      header: "작성자",
      render: (row) => row.created_by?.name,
    },
    { key: "created_at", header: "작성일", render: (row) => row.created_at },
    {
      key: "is_file",
      header: "파일 유무",
      render: (row) => (row.is_file ? "O" : "X"),
    },
    {
      key: "actions",
      header: "관리",
      render: (row) => (
        <button
          onClick={(e) => handleDelete(e, row.dns)}
          className="text-red-600 hover:text-red-700 underline"
        >
          삭제
        </button>
      ),
    },
  ];

  // 데이터 조회
  const fetchData = async () => {
    if (!projectId) return;
    setLoading(true);
    setError("");

    try {
      const params = {
        project: projectId,
        [searchField]: q || undefined,
        start_date: startDate || undefined,
        end_date: endDate || undefined,
        page,
        page_size: pageSize,
      };

      const res = await getProgressList(projectId, params);
      setRows(res.results ?? res);
      setTotal(res.count ?? res.total ?? res.length);
    } catch (e) {
      console.error(e);
      setError("목록을 불러오지 못했습니다.");
    } finally {
      setLoading(false);
    }
  };

  // 검색 실행 시
  const handleSearch = () => {
    setPage(1);
    setSearchTrigger((v) => v + 1);
  };

  // 🗑 삭제 기능
  const handleDelete = async (e, dns) => {
    e.stopPropagation();
    if (!window.confirm("삭제하시겠습니까?")) return;
    try {
      setDeleting(true);
      await softDeleteDoc(dns, true);
      alert("삭제되었습니다.");
      fetchData();
    } catch (err) {
      alert("삭제 실패");
    } finally {
      setDeleting(false);
    }
  };

  // 페이지 & 필터 변경 시 호출
  useEffect(() => {
    if (projectId) fetchData();
  }, [projectId, page, pageSize, searchTrigger]);

  return (
    <div className="max-w-8xl mx-auto p-6 rounded-2xl bg-gray-50">
      <PageHeader>주/월간 보고서</PageHeader>
      <div className="flex justify-between items-center"></div>

      {/* WorkOrder와 동일한 구조의 SearchBar */}
      <BoardToolbar
        right={
          <>
            <SearchBar
              q={q}
              onChangeQ={setQ}
              searchField={searchField}
              onChangeSearchField={setSearchField}
              dateFilter={dateFilter} // 추가
              onChangeDateFilter={setDateFilter} // 추가
              startDate={startDate}
              endDate={endDate}
              onDateChange={({ start, end }) => {
                setStartDate(start);
                setEndDate(end);
              }}
              onSearch={handleSearch}
              pageSize={pageSize}
              onChangePageSize={setPageSize}
            />
            <div className="flex gap-2">
              <button onClick={() => navigate(`new`)} className="btn-create">
                새 문서 등록
              </button>
              <button
                onClick={() =>
                  navigate(`/project/${projectId}/const/userTemplate`)
                }
                className=" btn-create"
              >
                템플릿 선택
              </button>
            </div>
          </>
        }
      />

      <BoardTable
        columns={columns}
        rows={rows}
        loading={loading}
        error={error}
        emptyText="보고서가 없습니다."
        onRowClick={(row) => navigate(`${row.dns}/view`)}
      />

      <div className="mt-4">
        <BoardPagination
          page={page}
          pageSize={pageSize}
          total={total}
          onPageChange={setPage}
        />
      </div>

      {/* {isModalOpen && (
        <Progress_new
          projectId={projectId}
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          on_newd={fetchData}
        />
      )} */}
    </div>
  );
}
